module.exports = __webpack_public_path__ + "img/waxing-lg.9af3fb2d.png";